<template>
  <h2 style="text-align: center;">FONTS</h2>
  <div v-if="Object.values(store.allFonts).length != 0">
    <MDBTabs v-model="controlName">
    <MDBTabNav tabsClasses="mb-3">
      <MDBTabItem tabId="DSTFonts" href="DSTFonts">DST Fonts</MDBTabItem>
      <MDBTabItem tabId="FontsFiles" href="FontsFiles">Fonts Files</MDBTabItem>
    </MDBTabNav>
      <MDBTabContent>
  <MDBTabPane tabId="DSTFonts">
      <MDBTabs v-model="DstControlName">
    <MDBTabNav tabsClasses="mb-3">
      <MDBTabItem tabId="AddFontRegularFile" href="AddFontRegularFile">Add Font Regular File</MDBTabItem>
      <MDBTabItem tabId="AddFontZipFile" href="AddFontZipFile">Add Font Zip File</MDBTabItem>
      <MDBTabItem tabId="AddFontMultiFile" href="AddFontMultiFile">Add Font Multi File</MDBTabItem>
      <!-- <MDBTabItem tabId="AddFontSVG" href="AddFontSVG">Add Font SVG</MDBTabItem> -->
    </MDBTabNav>

    <MDBTabContent>
      <MDBTabPane tabId="AddFontRegularFile">
        <form class="card col-md-10 offset-md-1">
      <div class="row p-2"
          style="display: flex;
          justify-content: center;">
        <div class="col-md-9">
          <MDBInput          
              label="Char set"
              v-model="charSet"
            />
          </div>
        <div class="col-md-1">
        <MDBInput
          label="Spaces"
          type="number"
          v-model="numOfSpaces"
          @change="ChangeSpace()"
          min="0"
        />
        </div>
        <div class="col-md-1" title="copy chars">
          <icon-svg
            icon="fluent:copy-16-regular"
            :height="30"
            :width="30"
            style="cursor: pointer"
            @click="copyCharSet(charSet)"
          />
        </div>
      </div>

      <div class="row p-2"
      style="display: flex;
          justify-content: center;
          gap: 10px;">
        <div class="col-md-3" title="Upload DST file">
          <MDBFile @change="uploadNewFont($event)"/>
        </div>
        
<div class="col-md-3">
          <vue-select
            class="form-control openLineInput font-selected"
            :close-on-select="true"
            :min="1"
            :options="
              getAllFontsWithNewOption()
            "
            label-by="fontName"
            value-by="fontID"
            searchable
            :model-value="selectedFont"
            @update:modelValue="
              (value) => {
                if (value !== null && value !== undefined) {
                  selectedFont = value;
                }
              }
            "
          >
          </vue-select>
        </div>

<div class="col-md-3">
        <MDBInput
          label="Font Name"
          type="text"
          :model-value="fontName"
          @update:modelValue="
            (value) => {
              if (value !== null && value !== undefined) {
                const pattern = /^[A-Za-z0-9]*$/;
                if (!pattern.test(value)) {
                  this.isValidFontName = false;
                } else {
                  this.isValidFontName = true;
                  this.fontName = value;
                }
              }
            }
          "
          v-if="selectedFont == 0"
        />
        <p v-if="!isValidFontName" style="color: red;">Invalid input. Only alphanumeric characters are allowed.</p>
        </div>

        <div class="col-md-3">
          <MDBInput
          label="Size Name"
          type="text"
          v-model="fontSizeName"
        />
        </div>
        <div class="col-md-1">
          <MDBInput
          label="Size inches"
          type="number"
          v-model="fontSizeInches"
          min="0"
        />
        </div>
        <div class="col-md-2">
          <MDBInput
          label="Sum layers"
          type="number"
          v-model="fontSumColors"
          min="1"
        />
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
          <label class="form-check-label" for="flexCheckDefault">
            only for monogram
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckDefault"
              v-model="onlyForMonogram"
            />
          </div>
          </div>
          <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
          <label class="form-check-label" for="flexCheckisRtl">
            is Rtl
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckisRtl"
              v-model="isRtl"
            />
          </div>
        </div>
      </div>
      <div class="col-md-2 p-3" title="Add new font" style="align-self: center">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="40"
          :width="40"
          style="cursor: pointer"
          @click="newFont()"
        />
        <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
      </div>
    </form>
      </MDBTabPane>
      <MDBTabPane tabId="AddFontZipFile">
        <form class="card col-md-10 offset-md-1">
      <div class="row p-2"
          style="display: flex;
          justify-content: center;">
        <div class="col-md-9">
          <MDBInput          
              label="Char set"
              v-model="charSet"
            />
          </div>
        <div class="col-md-1">
        <MDBInput
          label="Spaces"
          type="number"
          v-model="numOfSpaces"
          @change="ChangeSpace()"
          min="0"
        />
        </div>
        <div class="col-md-1" title="copy chars">
          <icon-svg
            icon="fluent:copy-16-regular"
            :height="30"
            :width="30"
            style="cursor: pointer"
            @click="copyCharSet(charSet)"
          />
        </div>
      </div>

      <div class="row p-2"
      style="display: flex;
          justify-content: center;
          gap: 10px;">
        <div class="col-md-3" title="Upload DST file">
          <MDBFile @change="uploadNewFont($event)"/>
        </div>
        <div class="col-md-3">
          <vue-select
            class="form-control openLineInput font-selected"
            :close-on-select="true"
            :min="1"
            :options="
              getAllFontsWithNewOption()
            "
            label-by="fontName"
            value-by="fontID"
            searchable
            :model-value="selectedFont"
            @update:modelValue="
              (value) => {
                if (value !== null && value !== undefined) {
                  selectedFont = value;
                }
              }
            "
          >
          </vue-select>
        </div>

<div class="col-md-3">
  <MDBInput
          label="Font Name"
          type="text"
          :model-value="fontName"
          @update:modelValue="
            (value) => {
              if (value !== null && value !== undefined) {
                const pattern = /^[A-Za-z0-9]*$/;
                if (!pattern.test(value)) {
                  this.isValidFontName = false;
                } else {
                  this.isValidFontName = true;
                  this.fontName = value;
                }
              }
            }
          "
          v-if="selectedFont == 0"
        />
        <p v-if="!isValidFontName" style="color: red;">Invalid input. Only alphanumeric characters are allowed.</p>
        </div>
        <div class="col-md-3">
          <MDBInput
          label="Size Name"
          type="text"
          v-model="fontSizeName"
        />
        </div>
        <div class="col-md-1">
          <MDBInput
          label="Size inches"
          type="number"
          v-model="fontSizeInches"
          min="0"
        />
        </div>
        <div class="col-md-2">
          <MDBInput
          label="Sum layers"
          type="number"
          v-model="fontSumColors"
          min="1"
        />
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
          <label class="form-check-label" for="flexCheckDefault">
            only for monogram
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckDefault"
              v-model="onlyForMonogram"
            />
          </div>
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
        <label class="form-check-label" for="flexCheckisRtl">
            is Rtl
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckisRtl"
              v-model="isRtl"
            />
          </div>
        </div>
      </div>

    <div class="row p-2"
          style="display: flex;
          justify-content: center; gap: 10px;">
          <label>Set files names template</label>
          <div style="display: flex;
                      gap: 10px;
                      justify-content: center;
                      align-items: center;">Upper Letters : 
        <div class="col-md-2">
          <MDBInput          
              label="Start with"
              v-model="startWithUpper"
            />
          </div>
          <span>[THE CHAR]</span>
        <div class="col-md-2">
          <MDBInput          
              label="End with"
              v-model="endWithUpper"
            />
          </div>
          <span>.DST</span>
          </div>
          <div style="display: flex;
                      gap: 10px;
                      justify-content: center;
                      align-items: center;">Lower Letters : 
        <div class="col-md-2">
          <MDBInput          
              label="Start with"
              v-model="startWithLower"
            />
          </div>
          <span>[THE CHAR]</span>
        <div class="col-md-2">
          <MDBInput          
              label="End with"
              v-model="endWithLower"
            />
          </div>
          <span>.DST</span>
          </div>
          <div style="display: flex;
                      gap: 10px;
                      justify-content: center;
                      align-items: center;">Number Letters : 
        <div class="col-md-2">
          <MDBInput          
              label="Start with"
              v-model="startWithNumber"
            />
          </div>
          <span>[THE CHAR]</span>
        <div class="col-md-2">
          <MDBInput          
              label="End with"
              v-model="endWithNumber"
            />
          </div>
          <span>.DST</span>
          </div>
          <div style="display: flex;
                      gap: 10px;
                      justify-content: center;
                      align-items: center;">SP Chars : 
        <div class="col-md-2">
          <MDBInput          
              label="Start with"
              v-model="startWithSP"
            />
          </div>
          <span>[THE CHAR]</span>
        <div class="col-md-2">
          <MDBInput          
              label="End with"
              v-model="endWithSP"
            />
          </div>
          <span>.DST</span>
          </div>
          <div>
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th>'@'</th>
                    <th>'!'</th>
                    <th>'#'</th>
                    <th>'$'</th>
                    <th>'&'</th>
                    <th>'*'</th>
                    <th>'('</th>
                    <th>')'</th>
                    <th>'?'</th>
                    <th>';'</th>
                    <th>'"'</th>
                    <th>','</th>
                    <th>'+'</th>
                    <th>'-'</th>
                    <th>'/'</th>
                    <th>'.'</th>
                    <th>':'</th>
                    <th>'%'</th>
                    <th>'='</th>
                    <th>'\''</th>
                    <th>'\\'</th>
                  </tr>
                </thead>
              <tbody>
                <tr>
                    <td>at</td>
                    <td>exc</td>
                    <td>pound</td>
                    <td>dollar</td>
                    <td>amp</td>
                    <td>asterisk</td>
                    <td>opPar</td>
                    <td>clPar</td>
                    <td>question</td>
                    <td>semicolon</td>
                    <td>quotes</td>
                    <td>comma</td>
                    <td>plus</td>
                    <td>minus</td>
                    <td>div</td>
                    <td>dot</td>
                    <td>colon</td>
                    <td>prec</td>
                    <td>equ</td>
                    <td>apost</td>
                    <td>slash</td>
                </tr>


                <!-- <tr>
              <th>'@'</th>
              <th>'!' </th>
              <th>'#'</th>
              <th>'$'</th>
              <th>'&'</th>
              <th>'*'</th>
              <th>'('</th>
              <th>')'</th>
              <th>'?'</th>
              <th>';'</th>
              <th>'\'</th>
              <th>','</th>
              <th>'+'</th>
              <th>'-'</th>
              <th>'/'</th>
              <th>'.'</th>
              <th>':'</th>
              <th>'%'</th>
              </tr> -->


                <!-- <tr>
                <td>"at"</td>
                <td>"exc"</td>
                <td>"pound"</td>
                <td>"dollar"</td>
                <td>"amp"</td>
                <td>"asterisk"</td>
                <td>"opPar"</td>
                <td>"clPar"</td>
                <td>"question"</td>
                <td>"semicolon"</td>
                <td>"quote"</td>
                <td>"comma"</td>
                <td>"plus"</td>
                <td>"minus"</td>
                <td>"div"</td>
                <td>"dot"</td>
                <td>"colon"</td>
                <td>"prec"</td>
                </tr> -->
              </tbody>
            </table>
          </div>
      </div>

      <div class="col-md-2 p-3" title="Add new font" style="align-self: center">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="40"
          :width="40"
          style="cursor: pointer"
          @click="newFont()"
        />
        <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
      </div>
    </form>
      </MDBTabPane>
      <MDBTabPane tabId="AddFontMultiFile">
        <form class="card col-md-10 offset-md-1">
      <div class="row p-2"
      style="display: flex;
          justify-content: center;">
        
        <div class="col-md-3">
          <vue-select
            class="form-control openLineInput font-selected"
            :close-on-select="true"
            :min="1"
            :options="
              getAllFontsWithNewOption()
            "
            label-by="fontName"
            value-by="fontID"
            searchable
            :model-value="selectedFont"
            @update:modelValue="
              (value) => {
                if (value !== null && value !== undefined) {
                  selectedFont = value;
                }
              }
            "
          >
          </vue-select>
        </div>

<div class="col-md-3">
  <MDBInput
          label="Font Name"
          type="text"
          :model-value="fontName"
          @update:modelValue="
            (value) => {
              if (value !== null && value !== undefined) {
                const pattern = /^[A-Za-z0-9]*$/;
                if (!pattern.test(value)) {
                  this.isValidFontName = false;
                } else {
                  this.isValidFontName = true;
                  this.fontName = value;
                }
              }
            }
          "
          v-if="selectedFont == 0"
        />
        <p v-if="!isValidFontName" style="color: red;">Invalid input. Only alphanumeric characters are allowed.</p>
        </div>
        <div class="col-md-3">
          <MDBInput
          label="Size Name"
          type="text"
          v-model="fontSizeName"
        />
        </div>
        <div class="col-md-1">
          <MDBInput
          label="Size inches"
          type="number"
          v-model="fontSizeInches"
          min="0"
        />
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
          <label class="form-check-label" for="flexCheckDefault">
            only for monogram
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckDefault"
              v-model="onlyForMonogram"
            />
          </div>
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
        <label class="form-check-label" for="flexCheckisRtl">
            is Rtl
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckisRtl"
              v-model="isRtl"
            />
          </div>
        </div>
        <div class="col-md-2">
          <MDBInput
          label="Sum layers"
          type="number"
          v-model="fontSumColors"
          min="1"
        />
        </div>
      </div>

      <div v-for="(line, index) in filesList" :key="index" class="row p-2"
          style="display: flex;
          justify-content: center;">
          <div class="col-md-2" title="Change DST file">
          <MDBFile @change="uploadNewFont($event)"/>
        </div>
        <div class="col-md-7">
          <MDBInput          
              label="Char set"
              v-model="line.charSet"
            />
          </div>
        <div class="col-md-1">
        <MDBInput
          label="Spaces"
          type="number"
          v-model="numOfSpaces"
          @change="ChangeSpace()"
          min="0"
        />
        </div>
        <div class="col-md-1" title="Copy Chars" style="width: fit-content;">
          <icon-svg
            icon="fluent:copy-16-regular"
            :height="30"
            :width="30"
            style="cursor: pointer"
            @click="copyCharSet(line.charSet)"
          />
        </div>
        <!-- <div v-if="contentDstFontFile != null" class="col-md-1" title="Add File" style="width: fit-content;">
          <icon-svg
            icon="fluent:add-12-regular"
            :height="30"
            :width="30"
            @click="AddFile()"
          />Add File
        </div> -->
      </div>

      <div class="row p-2"
          style="display: flex;
          justify-content: center;">
          <div class="col-md-2" title="Upload DST file">
          <MDBFile @change="uploadNewFont($event)"/>
        </div>
        <div class="col-md-7">
          <MDBInput          
              label="Char set"
              v-model="charSet"
            />
          </div>
        <div class="col-md-1">
        <MDBInput
          label="Spaces"
          type="number"
          v-model="numOfSpaces"
          @change="ChangeSpace()"
          min="0"
        />
        </div>
        <div class="col-md-1" title="Copy Chars" style="width: fit-content;">
          <icon-svg
            icon="fluent:copy-16-regular"
            :height="30"
            :width="30"
            style="cursor: pointer"
            @click="copyCharSet(charSet)"
          />
        </div>
         <!-- v-if="contentDstFontFile != null" -->
        <div class="col-md-1" title="Add File" style="width: fit-content;">
          <icon-svg
            icon="fluent:add-12-regular"
            :height="30"
            :width="30"
            style="cursor: pointer"
            @click="AddFile()"
          />Add File
        </div>
      </div>
      <div class="col-md-2 p-3" title="Add new font" style="align-self: center">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="40"
          :width="40"
          style="cursor: pointer"
          @click="newFontMultiFiles()"
        />
        <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
      </div>
    </form>
      </MDBTabPane>

      <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Font Name</th>
            <th>Preview</th>
            <th>Sizes</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(font, index) in store.getAllFonts()" :key="index">
            <td>{{ font.fontName }}</td>
            <td
              :style="{
                position: 'relative',
                top:
                  (58 -
                    (font.sizes[Object.keys(font.sizes)[0]].FontHeight *
                      ((47.0 /
                        font.sizes[Object.keys(font.sizes)[0]].FontHeight) *
                        254.0)) /
                      254.0) /
                    2 +
                  'px',
              }"
            >
              <div
                v-if="font.sizes[Object.keys(font.sizes)[0]].DictCharacters != undefined &&
                  (font.sizes[Object.keys(font.sizes)[0]].DictCharacters['T'] !=
                    null &&
                  font.sizes[Object.keys(font.sizes)[0]].DictCharacters['e'] !=
                    null &&
                  font.sizes[Object.keys(font.sizes)[0]].DictCharacters['s'] !=
                    null &&
                  font.sizes[Object.keys(font.sizes)[0]].DictCharacters['t'] !=
                    null)
                "
              >
                <TextPreview
                  :IDFontToPreview="font.fontID"
                  :IDSizeFontToPreview="Object.keys(font.sizes)[0]"
                  TextToPreview="Test"
                  :dpi="
                    (47.0 / font.sizes[Object.keys(font.sizes)[0]].FontHeight) *
                    254.0
                  "
                  superPos="normal"
                  :layersColors="[store.blackColorIdDst]"
                  :x="0"
                  :y="0"
                >
                </TextPreview>
                <!-- store.getAllColors() -->
              </div>
            </td>
            <td style="width: 530px;">{{ GetAllFontSizeNames(font) }}</td>
            <td>
              <span title="edit sizes">
                <icon-svg
                  :height="25"
                  :width="25"
                  icon="material-symbols:edit"
                  style="cursor: pointer"
                  @click="(editFontPopup = true), editFont(font)"
                />
              </span>
              <span title="edit kerning">
                <icon-svg
                  :height="25"
                  :width="25"
                  icon="fluent:text-edit-style-20-filled"
                  style="cursor: pointer"
                  @click="(editKerningPopup = true), editFontKerning(font)"
                />
              </span>
              <span title="edit vertical align">
                <icon-svg
                  :height="25"
                  :width="25"
                  icon="ic:outline-vertical-align-center"
                  style="cursor: pointer"
                  @click="(editVerticalPopup = true), editFontVerticalAlign(font)"
                />
              </span>
            </td>
            <td>
              <icon-svg
                :height="25"
                :width="25"
                icon="ic:baseline-delete"
                style="cursor: pointer"
                @click="removeFont(font.fontID)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
    </MDBTabContent>
      
    </MDBTabs>
  </MDBTabPane>
  <MDBTabPane tabId="FontsFiles">
        <form class="card col-md-10 offset-md-1">
      <div class="row p-2"
      style="display: flex;
          justify-content: center;
          gap: 10px;">
        <div class="col-md-3" title="Upload DST file">
          <MDBFile @change="uploadNewFontSVG($event)" accept=".woff,.otf,.ttf"/>
        </div>
        
<div class="col-md-3">
        <MDBInput
          label="Font Name"
          type="text"
          :model-value="fontName"
          @update:modelValue="
            (value) => {
              if (value !== null && value !== undefined) {
                const pattern = /^[A-Za-z0-9]*$/;
                if (!pattern.test(value)) {
                  this.isValidFontName = false;
                } else {
                  this.isValidFontName = true;
                  this.fontName = value;
                }
              }
            }
          "
          v-if="selectedFont == 0"
        />
        <p v-if="!isValidFontName" style="color: red;">Invalid input. Only alphanumeric characters are allowed.</p>
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
          <label class="form-check-label" for="flexCheckDefault">
            only for monogram
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckDefault"
              v-model="onlyForMonogram"
            />
          </div>
        </div>
        <div
          class="col-md-2 form-check"
          style="display: flex; position: relative"
        >
        <label class="form-check-label" for="flexCheckisRtl">
            is Rtl
          </label>
          &nbsp;
          <div class="form-check" style="display: grid; justify-content: center">
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckisRtl"
              v-model="isRtl"
            />
          </div>
        </div>
      </div>
      <div class="col-md-2 p-3" title="Add new font" style="align-self: center">
        <icon-svg
          icon="material-symbols:add-circle-outline"
          :height="40"
          :width="40"
          style="cursor: pointer"
          @click="newFontSvg()"
        />
        <div v-if="isLoading == true" style="display: grid; justify-items: center;"><span>Sending...</span><MDBSpinner /></div>
      </div>
    </form>
      
    <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Font Name</th>
            <th>Preview</th>
            <!-- <th>Sizes</th>
            <th>Edit</th> -->
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(font, index) in loadAllFontsFiles()" :key="index">
            <td>{{ font.fontName }}</td>
            <td
              :style="{
                position: 'relative',
                top: 0 +
                  // (58 -
                  //   (font.sizes[Object.keys(font.sizes)[0]].FontHeight *
                  //     ((47.0 /
                  //       font.sizes[Object.keys(font.sizes)[0]].FontHeight) *
                  //       254.0)) /
                  //     254.0) /
                  //   2 +
                  'px',
              }"
            >
            <div v-html="font.svgContent" style="height: 47px; max-width: 200px; overflow: hidden; display: block;"></div>
              <!-- <div
                v-if="font.sizes[Object.keys(font.sizes)[0]].DictCharacters != undefined &&
                  (font.sizes[Object.keys(font.sizes)[0]].DictCharacters['T'] !=
                    null &&
                  font.sizes[Object.keys(font.sizes)[0]].DictCharacters['e'] !=
                    null &&
                  font.sizes[Object.keys(font.sizes)[0]].DictCharacters['s'] !=
                    null &&
                  font.sizes[Object.keys(font.sizes)[0]].DictCharacters['t'] !=
                    null)
                "
              >
                <TextPreview
                  :IDFontToPreview="font.fontID"
                  :IDSizeFontToPreview="Object.keys(font.sizes)[0]"
                  TextToPreview="Test"
                  :dpi="
                    (47.0 / font.sizes[Object.keys(font.sizes)[0]].FontHeight) *
                    254.0
                  "
                  superPos="normal"
                  :layersColors="[store.blackColorIdDst]"
                  :x="0"
                  :y="0"
                >
                </TextPreview>
              </div> -->
            </td>
            <!-- <td style="width: 530px;">{{ GetAllFontSizeNames(font) }}</td> -->
            <!-- <td>
              <span title="edit sizes">
                <icon-svg
                  :height="25"
                  :width="25"
                  icon="material-symbols:edit"
                  @click="(editFontPopup = true), editFont(font)"
                />
              </span>
              <span title="edit kerning">
                <icon-svg
                  :height="25"
                  :width="25"
                  icon="fluent:text-edit-style-20-filled"
                  @click="(editKerningPopup = true), editFontKerning(font)"
                />
              </span>
              <span title="edit vertical align">
                <icon-svg
                  :height="25"
                  :width="25"
                  icon="ic:outline-vertical-align-center"
                  @click="(editVerticalPopup = true), editFontVerticalAlign(font)"
                />
              </span>
            </td> -->
            <td>
              <icon-svg
                :height="25"
                :width="25"
                icon="ic:baseline-delete"
                style="cursor: pointer"
                @click="removeFontFile(font.fontID)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </MDBTabPane>
    </MDBTabContent>

    </MDBTabs>
  
  
  </div>
  



  <!-- .modal to edit font size -->
  <MDBModal
    id="editFontPopup"
    tabindex="-1"
    labelledby="editFontPopupTitle"
    v-model="editFontPopup"
    centered
    scrollable
  >
    <MDBModalHeader>
      <MDBModalTitle id="editFontPopupTitle" :style="{ width: '100%' }">
        <h4>
          {{ FontToPopup.fontName }}
        </h4>
      </MDBModalTitle>
    </MDBModalHeader>

    <MDBModalBody style="max-width: 80vw">
      <div class="row">
              <div class="col-md-6">
                <div class="font-colors-container">
                  <template v-for="(defaultColor, index) in FontToPopup.defaultFontColors" :key="index">
                    <SelectColor v-model="store.allFonts.value[FontToPopup.fontID].defaultFontColors[index]">
                    </SelectColor>
                  </template>
                </div>

                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Size Name</th>
                      <th>Size in inches</th>
                      <th v-if="FontToPopup.sizes.length>1">to delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(size, index) in store.getAllFontSizes(
                        FontToPopup.fontID
                      )"
                      :key="index"
                    >
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="size.sizeName"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          v-model="size.sizeInches"
                        />
                      </td>
                      <td title="Remove font size">
                        <icon-svg
                          v-if="Object.values(FontToPopup.sizes).length > 1"
                          :height="25"
                          :width="25"
                          icon="ic:baseline-delete"
                          style="cursor: pointer"
                          @click="
                            removeFontSize(FontToPopup.fontID, size.sizeID)
                          "
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="fontSizeNameNew"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          v-model="fontSizeInchesNew"
                        />
                      </td>
                      <td>
                        <input
                          type="file"
                          id="file"
                          class="form-control custom-file-input"
                          @change="uploadNewFontSize($event)"
                        />
                      </td>
                      <td>
                        <div title="Add font size">
                          <icon-svg
                            icon="material-symbols:add-circle-outline"
                            :height="25"
                            :width="25"
                            style="cursor: pointer"
                            @click="addFontSize()"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="showWaitMessage == true" style="color: red; font-size: 26px;">Wait!</div>
              </div>
              <div class="col-md-6">
                <div class="row" style="height: 500px; overflow-y: scroll">
                  <div
                    class="col-md-2"
                    style="
                      display: block;
                      margin-bottom: 50px;
                      position: relative;
                      height: 80px;
                    "
                    v-for="(char, index) in FontToPopup.sizes[
                      Object.keys(FontToPopup.sizes)[0]
                    ].DictCharacters"
                    :key="index"
                  >
                    <div style="text-align: center; width: 100%">
                      {{ Object.values(char)[0] }}
                    </div>
                    <div
                      style="
                        position: relative;
                        margin-top: 10px;
                        margin-bottom: 20px;
                      "
                    >
                      <DSTPreview
                        :dwidth="this.ratio * char.dstfile.pixelWidth"
                        :dheight="this.ratio * char.dstfile.pixelHeight"
                        :dstFile="char.dstfile"
                        :layersColors="FontToPopup.defaultFontColors"
                        :left="0"
                        :top="0"
                      >
                      </DSTPreview>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn color="secondary" @click="editFontPopup = false"> Close </MDBBtn>
    </MDBModalFooter>
  </MDBModal>

  <!-- .modal to edit kerning -->
  <MDBModal
    id="editKerningPopup"
    tabindex="-1"
    labelledby="editKerningPopupTitle"
    v-model="editKerningPopup"
    centered
    scrollable
  >
    <MDBModalHeader>
      <MDBModalTitle id="editKerningPopupTitle" :style="{ width: '100%' }">
        <h4>
          {{ FontToPopup.fontName }}
        </h4>
      </MDBModalTitle>
    </MDBModalHeader>

    <MDBModalBody style="max-width: 80vw">
      <div title="Add Kerning">
              <icon-svg
                icon="material-symbols:add-circle-outline"
                :height="40"
                :width="40"
                style="cursor: pointer"
                @click="addFontKerning()"
              />
            </div>
            <div class="row">
              <div class="col-md-6">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Left chars</th>
                      <th>Right chars</th>
                      <th>Distance</th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(kerning, index) in FontToPopup.kerning"
                      :key="index"
                      @click="editKerning(kerning)"
                      :class="kerning == kerningPreview ? 'activeLine' : 'null'"
                    >
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="kerning.leftChars"
                          @foucs="editKerning(kerning)"
                          @change="changeLeftTextPreview()"
                          @keyup="changeLeftTextPreview()"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          @foucs="editKerning(kerning)"
                          v-model="kerning.rightChars"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          v-model.number="kerning.distance"
                        />
                      </td>
                      <td>
                        <div title="remove kerning">
                          <icon-svg
                            icon="ic:baseline-delete"
                            :height="25"
                            :width="25"
                            style="cursor: pointer"
                            @click="
                              removeFontKerning(FontToPopup.fontID, index)
                            "
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-img-top">
                    <div style="height: 200px; position: relative">
                      <div
                        class="targetLeft"
                        style="position: absolute; left: 200px"
                      >
                        <TextPreview
                          :IDFontToPreview="FontToPopup.fontID"
                          :IDSizeFontToPreview="Object.keys(FontToPopup.sizes)[0]"
                          :TextToPreview="kerningPreview.leftChars"
                          :dpi="dpi"
                          superPos="alignRight"
                          :layersColors="[store.blackColorIdDst]"
                        >
                        </TextPreview>
                      </div>
                      <div
                        class="targetRight"
                        :style="{
                          position: 'absolute',
                          left:
                            200 +
                            (maxWidthLeftKerning * this.dpi) / 254.0 +
                            kerningPreview.distance *
                              (this.dpi / 254.0) *
                              this.kerningFontSize.sizeInches +
                            'px',
                        }"
                      >
                        <TextPreview
                          :IDFontToPreview="FontToPopup.fontID"
                          :IDSizeFontToPreview="Object.keys(FontToPopup.sizes)[0]"
                          :TextToPreview="kerningPreview.rightChars"
                          :dpi="dpi"
                          superPos="alignLeft"
                          :layersColors="[store.blackColorIdDst]"
                          
                        >
                        <!-- :x="0"
                          :y="0" -->
                        </TextPreview>
                      </div>
                      <div
                        class="row"
                        style="height: 200px; position: absolute"
                      >
                        <Moveable
                          className="moveable"
                          :target="['.targetRight']"
                          :draggable="true"
                          :innerBounds="{
                            left: 500,
                            top: 0,
                            width: 0,
                            height: 0,
                          }"
                          :snappable="true"
                          :origin="false"
                          @drag="OnDrag($event)"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="card">
                    <div class="row p-2">
                      <div class="col-md-4">
                        <label class="form-text"> Enter text to preview </label>
                        <input
                          class="form-control"
                          type="text"
                          v-model="TextToPreview"
                        />
                      </div>
                      <div class="col-md-4">
                        <label class="form-text"> Id size of text </label>
                        <vue-select
                          :close-on-select="true"
                          :min="1"
                          :options="store.getAllFontSizesToSelect(FontToPopup.fontID)"
                          label-by="sizeName"
                          value-by="sizeID"
                          searchable
                          :model-value="IDSizeFontToPreview"
                          @update:modelValue="(value) => {
                          if (value !== null && value !== undefined) { 
                          IDSizeFontToPreview = value
                          }
                        }"
                        >
                        </vue-select>
                      </div>
                    </div>
                    &nbsp;
                    <div class="card" style="height: 200px">
                      <TextPreview
                        :IDFontToPreview="FontToPopup.fontID"
                        :IDSizeFontToPreview="IDSizeFontToPreview"
                        :TextToPreview="TextToPreview"
                        :dpi="dpi"
                        superPos="normal"
                        :layersColors="[store.blackColorIdDst]"
                        :x="0"
                        :y="0"
                      >
                      </TextPreview>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn color="secondary" @click="editKerningPopup = false, clearTestText()"> Close </MDBBtn>
    </MDBModalFooter>
  </MDBModal>

    <!-- .modal to edit vertical align -->
  <MDBModal
    id="editVerticalPopup"
    tabindex="-1"
    labelledby="editVerticalPopupTitle"
    v-model="editVerticalPopup"
    centered
    scrollable
  >
    <MDBModalHeader>
      <MDBModalTitle id="editVerticalPopupTitle" :style="{ width: '100%' }">
        <h4>
          {{ FontToPopup.fontName }}
        </h4>
      </MDBModalTitle>
    </MDBModalHeader>

    <MDBModalBody style="max-width: 80vw; height: 70vh;">
      <!-- <div title="Add Kerning">
              <icon-svg
                icon="material-symbols:add-circle-outline"
                :height="40"
                :width="40"
                @click="addFontKerning()"
              />
            </div> -->
            <div class="grid-div-body">
              <div>
                <!-- <div v-for="i in getLines()" :key="i" style="position: absolute; top: 0px;"> FontToPopup.sizes[Object.keys(this.FontToPopup.sizes)[0]]-->
                  <div class="vertical-line-div" :style="{'position': 'relative', 'top': ((FontToPopup.sizes[Object.keys(FontToPopup.sizes)[0]].FontHeight * (dpi / 254)) * i) + 'px'}">
                  <TextVerticalAlign
                        :IDFontToPreview="FontToPopup.fontID"
                        :IDSizeFontToPreview="IDSizeFontToPreview"
                        :TextToPreview="store.getTextToPreview(FontToPopup.fontID, Object.keys(this.FontToPopup.sizes)[0])"
                        :dpi="
                          (47.0 / FontToPopup.sizes[Object.keys(FontToPopup.sizes)[0]].FontHeight) *
                          254.0
                        "
                        superPos="normal"
                        :layersColors="store.getAllColors()"
                        :x="0"
                        :y="0">
                      </TextVerticalAlign>
                    </div>
              </div>
            </div>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn color="secondary" id="close-vertical-modal-btn" @click="editVerticalPopup = false, clearTestText()"> Close </MDBBtn>
    </MDBModalFooter>
  </MDBModal>

</template>


<script>
import { storeToRefs } from "pinia";
import { designerStore } from "@/stores/designerStore";
import DSTPreview from "./DSTPreview.vue";
import VueSelect from "vue-next-select";
import TextPreview from "./TextPreview.vue";
import SelectColor from "./SelectColor.vue";
import TextVerticalAlign from "./TextVerticalAlign.vue";
import Moveable from "vue3-moveable";
import {
  MDBInput,
  MDBFile,
  MDBBtn,
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,  
  MDBSpinner,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
} from "mdb-vue-ui-kit";
import { ref } from "vue";

export default {
  setup() {
    const store = designerStore();
    const { fontList } = storeToRefs(store);
    const editFontPopup = ref(false);
    const editKerningPopup = ref(false);
    const editVerticalPopup = ref(false);
    const controlName = ref("DSTFonts");
    const DstControlName = ref("AddFontRegularFile")

    

    return {
      store,
      fontList,
      editFontPopup,
      editKerningPopup,
      editVerticalPopup,
      controlName,
      DstControlName
    };
  },
  components: {
    DSTPreview,
    TextPreview,
    TextVerticalAlign,
    VueSelect,
    Moveable,
    MDBInput,
    MDBFile,
    MDBBtn,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBSpinner,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    SelectColor,
  },
  data() {
    return {
      charSet:
        // "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz@!#$&*()?;',+-/:%",
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz@!#$&*()?;\",+-/.:%='\\",
      startWithUpper: "upper ",
      endWithUpper: "",
      startWithLower: "lower ",
      endWithLower: "",
      startWithNumber: "number ",
      endWithNumber: "",
      startWithSP: "SP ",
      endWithSP: "",

      numOfSpaces: 0,
      fontName: "",
      isValidFontName: true,
      selectedFont: 0,
      fontSizeName: "",
      fontSizeInches: 1,
      fontSumColors: 1,
      contentDstFontFile: null,
      fileType: "",

      KerningPopupOpen: false,
      VertivalPopupOpen: false,
      popupKerningCount: 0,

      leftCharsNew: "",
      rightCharsNew: "",

      leftCharsPreview: "",
      rightCharsPreview: "",
      distanceKerningPreview: 20 * (100 / 254),
      kerningPreview: {
        leftChars: "",
        rightChars: "",
        distance: 0,
      },
      dpi: 254.0,
      distanceKerningNew: 20 * (100 / 254),
      FontPopupOpen: false,
      kerningFontSize: null,
      FontToPopup: null,
      popupFontCount: 0,

      charSetNew:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz@!#$&*()?;\",+-/.:%='\\",
      fontSizeNameNew: "",
      fontSizeInchesNew: 1,
      contentDstFontFileNew: null,
      onlyForMonogram: false,
      isRtl: false,

      filesList: [],

      ratio: null,

      colors: null,

      maxWidthLeftKerning: 0,
      TextToPreview: "",
      IDFontToPreview: null,
      IDSizeFontToPreview: null,

      isLoading: false,

      showWaitMessage: false,
      contentFontFile: null,
      fontFileName: "",
      svgContent: "",
    };
  },
  beforeMount() {
    if(Object.values(this.store.allFonts.value).length != 0) {
      this.IDFontToPreview = Object.values(this.store.allFonts.value)[0].fontID;
      this.IDSizeFontToPreview = Object.values(this.store.getAllFontSizes(this.IDFontToPreview))[0].sizeID;
    }
  },
  methods: {
    loadAllFontsFiles() {
      var allFontsFiles = this.store.getAllFontsFiles();
      allFontsFiles.forEach(async font => {
        // Call loadFontSVG for each font, passing its relative path and font name
        // await this.store.loadText(font.relativeFontPath, 'Test', this.store.blackColorIdSvg).then(({ svgTag, width, height }) => {
        //   console.log('Generated SVG:', svgTag);
        //   console.log('Width:', width, 'Height:', height);
        //   font.svgContent = svgTag;
        //   // Insert the SVG into your app
        //   // document.getElementById('svg-container').innerHTML = svgTag;
        // })
        // .catch(err => {
        //   console.error('Error loading text:', err);
        // });
        var result = this.store.loadText(0, 'Test', 20, this.store.blackColorIdSvg, font.fontID);
        font.svgContent = result.svg;
    });
    return allFontsFiles;
  },
    clearAll() {
      this.filesList = [];
      this.charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz@!#$&*()?;\",+-/.:%='\\",
      this.startWithUpper = "upper ";
      this.endWithUpper = "";
      this.startWithLower = "lower ";
      this.endWithLower = "";
      this.startWithNumber = "number ";
      this.endWithNumber = "";
      this.startWithSP = "SP ";
      this.endWithSP = "";

      this.numOfSpaces = 0;
      this.fontName = "";
      this.selectedFont = 0;
      this.fontSizeName = "";
      this.fontSizeInches = 1;
      this.fontSumColors = 1;
      this.contentDstFontFile = null;
      this.contentFontFile = null;
      this.fontFileName = "";
      this.fileType = "";
    },
    clearTestText() {
      this.TextToPreview = "";
    },
    getAllFontsWithNewOption() {
      var fontsList = this.store.getAllFonts();
      var list = [];
      list.push({fontID: 0, fontName: 'New Font'});
      fontsList.forEach(font => list.push({
        fontID: font.fontID, fontName: font.fontName
      }));
      return list;
    },
    AddFile() {
      this.filesList.push({
        charSet: this.charSet,
        contentDstFontFile: this.contentDstFontFile,
      });
      this.charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz@!#$&*()?;\",+-/.:%='\\",
      this.contentDstFontFile = null;
      this.numOfSpaces = 0;
    },
    async newFontMultiFiles() {
      this.isLoading = true;
      if(this.selectedFont == 0) { //אם בחר פונט חדש
        await this.store.newFontMultiFiles(
          {StartWithUpper: this.startWithUpper,
            EndWithUpper: this.endWithUpper,
            StartWithLower: this.startWithLower,
            EndWithLower: this.endWithLower,
            StartWithNumber: this.startWithNumber,
            EndWithNumber: this.endWithNumber,
            StartWithSP: this.startWithSP,
            EndWithSP: this.endWithSP},
          this.filesList,
          this.fontName,
          this.fileType,
          this.fontSizeName,
          this.fontSizeInches,
          this.fontSumColors,
          this.onlyForMonogram,
          this.isRtl
        );
      } else { //אם מוסיף גודל חדש לפונט קיים
        await this.store.newFontSizeMultiFiles(
          {StartWithUpper: this.startWithUpper,
            EndWithUpper: this.endWithUpper,
            StartWithLower: this.startWithLower,
            EndWithLower: this.endWithLower,
            StartWithNumber: this.startWithNumber,
            EndWithNumber: this.endWithNumber,
            StartWithSP: this.startWithSP,
            EndWithSP: this.endWithSP},
            this.filesList, this.selectedFont, this.fileType,
          this.fontSizeName,
          this.fontSizeInches, this.fontSumColors);
      }
      this.isLoading = false;
      this.clearAll();
    },
    async addFontSize() {
      this.showWaitMessage = true;
      //charSet, fileNameTemplates , fontID, fileType, contentDstFontFile, fontSizeName, fontSizeInches
      await this.store.newFontSize(
        this.charSetNew,
        {StartWithUpper: this.startWithUpper,
          EndWithUpper: this.endWithUpper,
          StartWithLower: this.startWithLower,
          EndWithLower: this.endWithLower,
          StartWithNumber: this.startWithNumber,
          EndWithNumber: this.endWithNumber,
          StartWithSP: this.startWithSP,
          EndWithSP: this.endWithSP},
          this.FontToPopup.fontID,
          this.fileType,
        this.contentDstFontFileNew,
        this.fontSizeNameNew,
        this.fontSizeInchesNew
      );
      this.showWaitMessage = false;
    },
    async newFontSvg(){
      this.isLoading = true;
      await this.store.newFontSVG(
        this.fontName,
        this.fontFileName,
        this.contentFontFile,
        this.onlyForMonogram,
        this.isRtl
      );
      this.isLoading = false;
      this.clearAll();
    },
    async newFont() {
      this.isLoading = true;
      if(this.selectedFont == 0) { //אם בחר פונט חדש
      await this.store.newFont(
        this.charSet,
    {StartWithUpper: this.startWithUpper,
          EndWithUpper: this.endWithUpper,
          StartWithLower: this.startWithLower,
          EndWithLower: this.endWithLower,
          StartWithNumber: this.startWithNumber,
          EndWithNumber: this.endWithNumber,
          StartWithSP: this.startWithSP,
          EndWithSP: this.endWithSP},
        // this.startWithUpper,
        // this.endWithUpper,
        // this.startWithLower,
        // this.endWithLower,
        // this.startWithNumber,
        // this.endWithNumber,
        // this.startWithSP,
        // this.endWithSP,
        this.fontName,
        this.fileType,
        this.contentDstFontFile,
        this.fontSizeName,
        this.fontSizeInches,
        this.fontSumColors,
        this.onlyForMonogram,
        this.isRtl
      );      
      } else { //אם מוסיף גודל חדש לפונט קיים
        await this.store.newFontSize(this.charSet,
        {StartWithUpper: this.startWithUpper,
          EndWithUpper: this.endWithUpper,
          StartWithLower: this.startWithLower,
          EndWithLower: this.endWithLower,
          StartWithNumber: this.startWithNumber,
          EndWithNumber: this.endWithNumber,
          StartWithSP: this.startWithSP,
          EndWithSP: this.endWithSP},
          this.selectedFont,
          this.fileType,
          this.contentDstFontFile,
          this.fontSizeName,
          this.fontSizeInches, this.fontSumColors);
      }
      this.isLoading = false;
      this.clearAll();
    },    
    uploadNewFontSVG(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.contentFontFile = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      var s = (event.target.files[0].name).split(".");
      this.fileType = s[s.length - 1];
      this.fontFileName = event.target.files[0].name;
    },
    uploadNewFont(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.contentDstFontFile = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      var s = (event.target.files[0].name).split(".");
      this.fileType = s[s.length - 1];
    },
    uploadNewFontSize(event) {
      const reader = new FileReader();
      reader.onload = () => {
        this.contentDstFontFileNew = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    },
    removeFont(fontID) {
      this.store.removeFont(fontID);
    },
    removeFontFile(fontFileID) {
      this.store.removeFontFile(fontFileID);
    },
    editFontKerning(font) {
      this.clearTestText();
      this.KerningPopupOpen = true;
      this.FontToPopup = font;
      this.dpi =
        (150.0 /
          this.FontToPopup.sizes[[Object.keys(this.FontToPopup.sizes)[0]]]
            .FontHeight) *
        254.0;
      this.popupKerningCount++;
      this.getBiggestFontSize();
      if (font.kerning.length == 0) {
        this.addFontKerning();
      } else {
        this.kerningPreview = font.kerning[0];
        this.CalculateMaxWidth();
      }
    },
    editFontVerticalAlign(font) {
      this.clearTestText();
      this.VertivalPopupOpen = true;
      this.FontToPopup = font;
      this.dpi =
        (150.0 /
          this.FontToPopup.sizes[[Object.keys(this.FontToPopup.sizes)[0]]]
            .FontHeight) *
        254.0;
      this.popupKerningCount++;
      this.getBiggestFontSize();
      if (font.kerning.length == 0) {
        this.addFontKerning();
      } else {
        this.kerningPreview = font.kerning[0];
        this.CalculateMaxWidth();
      }
    },
    getLines() {
      var someCharsInLine = 6;
      var someChars = Object.values(Object.values(this.FontToPopup.sizes)[0].DictCharacters).length;
      var x = parseInt(someChars / someCharsInLine);
      return (someChars % someCharsInLine) > 1 ? x + 1 : x;
    },
    editFont(font) {
      this.store.currentEditingProps.isDesignDst = true;
      this.FontPopupOpen = true;
      this.FontToPopup = font;
      //if default font colors is empty or undefined, add colors count layerColors
      if(this.FontToPopup.defaultFontColors == undefined || this.FontToPopup.defaultFontColors.length == 0) {
        this.FontToPopup.defaultFontColors = this.store.getDefaultColorArray(this.FontToPopup.layerCount || 1);
      }

      this.popupFontCount++;
      this.ratio = 100 / this.getMaxHeight().pixelHeight;
    },
    getBiggestFontSize() {
      this.kerningFontSize = Object.values(this.FontToPopup.sizes).reduce(
        (x, y) => (x.sizeInches > y.sizeInches ? x : y)
      );
    },
    getMaxHeight() {
      this.getBiggestFontSize();
      var res = Object.values(this.kerningFontSize.DictCharacters)[0].dstfile;

      for (
        var i = 1;
        i < Object.keys(this.kerningFontSize.DictCharacters).length;
        i++
      ) {
        res =
          Object.values(this.kerningFontSize.DictCharacters)[i].dstfile
            .pixelHeight > res.pixelHeight
            ? Object.values(this.kerningFontSize.DictCharacters)[i].dstfile
            : res;
      }
      return res;
    },
    getAllHeights() {
      var res = [];
      for (
        var i = 0;
        i <
        Object.keys(
          this.FontToPopup.sizes[Object.keys(this.FontToPopup.sizes)[0]]
            .DictCharacters
        ).length;
        i++
      ) {
        res.push(
          Object.values(
            this.FontToPopup.sizes[Object.keys(this.FontToPopup.sizes)[0]]
              .DictCharacters
          )[i].dstfile.pixelHeight
        );
      }
      return res;
    },
    getAllWidths() {
      var res = [];
      for (
        var i = 0;
        i <
        Object.keys(
          this.FontToPopup.sizes[Object.keys(this.FontToPopup.sizes)[0]]
            .DictCharacters
        ).length;
        i++
      ) {
        res.push(
          Object.values(
            this.FontToPopup.sizes[Object.keys(this.FontToPopup.sizes)[0]]
              .DictCharacters
          )[i].dstfile.pixelWidth
        );
      }
      return res;
    },
    removeFontSize(fontID, sizeID) {
      this.store.removeFontSize(fontID, sizeID);
    },
    async copyCharSet(chars) {
      console.log('copy func');
      try {
        await navigator.clipboard.writeText(chars);
      }
      catch (err) {
        console.error('Could not write to clipboard', err);
      }

      // const element = this.charSet;
      // element.select();
      // element.setSelectionRange(0, 99999);
      // document.execCommand('copy');

      // navigator.clipboard
      //   .writeText(this.charSet)
      //   .then(() => {
      //     console.log('copies');
      //     alert("Copied to clipboard");
      //   })
      //   .catch((e) => alert(e));
    },
    ChangeSpace() {
      this.charSet = this.charSet.split(" ").join("");
      this.charSet = this.charSet
        .split("")
        .join(Array(parseInt(this.numOfSpaces) + 1).join(" "));
    },
    GetAllFontSizeNames(font) {
      return Object.values(font.sizes)
        .map((x) => x.sizeName)
        .join(" , ");
    },
    exitPopup() {
      this.FontPopupOpen = false;
      this.fontSizeNameNew = "";
      this.fontSizeInchesNew = 1;
    },
    exitKerningPopup() {
      this.KerningPopupOpen = false;
    },
    exitVerticalPopup() {
      this.VertivalPopupOpen = false;
    },
    addFontKerning() {
      const newKerning = {
        distance: 0,
        leftChars: "",
        rightChars: "",
      };
      this.store.addFontKerning(this.FontToPopup.fontID, newKerning);
      this.kerningPreview = newKerning;
      this.CalculateMaxWidth();
    },
    removeFontKerning(fontID, index) {
      this.store.removeFontKerning(fontID, index);
      this.editKerning(this.FontToPopup.kerning[0]);
    },
    OnDrag(e) {
      this.kerningPreview.distance =
        (e.translate[0] * 254.0) /
        this.dpi;
        // (e.transform.substring(11, e.transform.indexOf("px")) * 254.0) /
        // this.dpi;
    },
    OnDragVartical(e) {
      console.log('save this: ', (e.transform.substring(11, e.transform.indexOf("px")) * 254.0) / this.dpi);
      // this.kerningPreview.distance =
      //   (e.transform.substring(11, e.transform.indexOf("px")) * 254.0) /
      //   this.dpi;
    },
    CalculateMaxWidth() {
      this.maxWidthLeftKerning =
        this.kerningPreview.leftChars != ""
          ? [...this.kerningPreview.leftChars]
              .map(
                (x) =>
                  this.store.allFonts.value[this.FontToPopup.fontID].sizes[
                    Object.keys(
                      this.store.allFonts.value[this.FontToPopup.fontID].sizes
                    )[0]
                  ].DictCharacters[x] != undefined ? this.store.allFonts.value[this.FontToPopup.fontID].sizes[
                    Object.keys(
                      this.store.allFonts.value[this.FontToPopup.fontID].sizes
                    )[0]
                  ].DictCharacters[x].dstfile.pixelWidth : null
              )
              .reduce((x, y) => (x > y ? x : y))
          : 0;
    },

    editKerning(kerning) {
      this.kerningPreview = kerning;
      this.CalculateMaxWidth();
    },
    changeLeftTextPreview() {
      this.CalculateMaxWidth();
    },
// async getTextFromFontFile(path, text) {
//   // Return a promise to handle asynchronous loading
//   var svg = await this.loadText(path, text);
//   return svg;
// },

  },
};
</script>

<style scoped>
.moveable {
  --moveable-color: transparent !important;
}
.activeLine {
  background-color: rgb(213, 228, 236);
}
.grid-div-body {
  display: grid;
}
.font-colors-container {
    display: flex;
    gap: 20px;
}

</style>
